import PropTypes from 'prop-types';
import React from 'react';

import Polygon from './Polygon';

/**
* -Polygons-
* Polygons component
**/
export default class Polygons extends React.Component {

	state = {
		polygons: []
	}

	updatePolygons = () => {

		// Combine polygons to array (if object)
		let polygons;

		if (!Array.isArray(this.props.polygons)) {

			polygons = Object
				.keys(this.props.polygons)
				.map((key) => this.props.polygons[key]);
			polygons = [].concat(...polygons);

		} else {

			polygons = this.props.polygons;
		}

		polygons = (polygons === undefined) ? [] : polygons;

		this.setState({ polygons: polygons });
	}

	componentDidMount() {

		this.updatePolygons();
	}

	componentDidUpdate(prevProps) {

		if (this.props.polygons !== prevProps.polygons) {

			this.setState({ polygons: [] }, () => {

				this.updatePolygons();
			});
		}
	}

	render() {

		const polygons = this.state.polygons.map((polygon, i) =>
			<Polygon
				path={ polygon.path }
				color={ polygon.color }
				fillColor={ polygon.fillColor }
				key={ i }
				{ ...this.props }
			/>
		);

		return (
			<div>
				{ polygons }
			</div>
		)
	}
}

Polygons.propTypes = {
	polygons: PropTypes.oneOfType([
		PropTypes.array,
		PropTypes.object
	]),
}



// WEBPACK FOOTER //
// ./src/components/googlemaps/Polygons.js